// extracted by mini-css-extract-plugin
export default {"container":"yp-z","brandName":"zp-z","productName":"Ap-z","productNamePdpEnhancements":"Bp-z","breakLongProductName":"Cp-z"};